<template>
  <el-input
    v-if="props.config?.number === true"
    v-bind="$attrs"
    v-model.number="$attrs.modelValue"
    :autosize="{ minRows: 4 }"
    :showWordLimit="Boolean($attrs?.maxlength)"
  >
    <template v-if="props.config?.append" #append>
      {{ props.config?.append }}
    </template></el-input
  >
  <el-input
    v-else
    v-bind="$attrs"
    v-model.trim="$attrs.modelValue"
    :autosize="{ minRows: 4 }"
    :showWordLimit="Boolean($attrs?.maxlength)"
  >
    <template v-if="props.config?.append" #append>
      {{ props.config?.append }}
    </template></el-input
  >
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "form-input",
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    return {
      props
    };
  }
});
</script>
